import React, { useState } from 'react';
import ProductListPage from '../ProductList/ProductListPage';
import HeroSection from '../Plugins/HeroSection/HeroSection';
import StickyNav from '../Plugins/StickyNav/StickyNav';
import PromoBanner from '../Common/PromoBanner';
import IRSTaxModal from './IRSTaxModal';
import { ProductFaq } from '../Product/ProductFaq';

const AllTaxFormPage = (props) => {
  const [efileModal, setEfileModal] = useState(false);
  const openEfileModal = () => {
    setEfileModal(true);
  };
  const closeEfileModal = () => {
    setEfileModal(false);
  };
  return (
    <>
    <div className="all_tax_form_page container-center-lg">
      {/* {availableSku} */}
      {props.pageData.Hero && (
        <div className="margin-main-section">
          <PromoBanner page="ALL_TAX" />
          <HeroSection
            {...props.pageData.Hero}
            openModal={openEfileModal}
            navBodyClass="product_in_list"
          />
        </div>
      )}
      <StickyNav
        navigationData={props.pageData.ProductSections[0].Products}
        navBodyClass="product_in_list"
      >
        <ProductListPage
          {...props}
          childrenRoutes={props.childrenRoutes}
          location={props.location}
          pageData={props.pageData}
          contentVariable={props.contentVariable}
          openModal={openEfileModal}
        />
      </StickyNav>
      <IRSTaxModal open={efileModal} close={closeEfileModal} openModal={openEfileModal} />
    </div>
    <div>
      {props.pageData.HasFaq && (
        <ProductFaq
          FaqDescription={props.pageData.FaqDescription}
          HasEfileModal={props.pageData.HasEfileModal}
        />
      )}
    </div>
    </>
  );
};

export default AllTaxFormPage;
